export default "__VITE_ASSET__DYrRUJ2c__"